import PageLayout from "@/components/PageLayout";
import PageHero from "@/components/PageHero";
import { Check } from "@/components/Icon";
import { Link } from "react-router-dom";
import heroImg from "@/assets/hero/borduren.webp";
import borduurImg from "@/assets/techniques/borduren.webp";

const Borduren = () => (
  <PageLayout
    title="Borduren"
    metaDescription="Borduren bij Magic Print Den Haag. Professioneel borduurwerk op kleding, polo's, caps en bedrijfskleding. Borduurkaart altijd gratis. Vanaf 25 stuks."
    ogImage={heroImg}
    hero={
      <PageHero
        image={heroImg}
        alt="Borduren bij Magic Print"
        title="Borduren"
        subtitle="Professioneel borduurwerk op kleding, polo's, caps en bedrijfskleding."
      />
    }
  >


    <p className="text-lg text-muted-foreground mb-8 leading-relaxed">
      De mogelijkheden van textiel borduren zijn ontzettend uitgebreid. Of u nu een t-shirt, jas, sweater, hoodie, ochtendjas of zelfs een cap wilt laten borduren: alles is mogelijk. Bij Magic Print kunt u uw eigen logo, tekst of afbeelding professioneel en duurzaam aan laten brengen op een textiel(soort) naar keuze. Wij borduren vanaf 20 stuks op kleding die wij zelf leveren.
    </p>

    <section className="mb-12 grid md:grid-cols-2 gap-8 items-center">
      <div>
        <h2 className="text-2xl font-bold mb-4 text-[#0a2933]">Professionele uitstraling</h2>
        <p className="text-muted-foreground mb-4">
          Bij bedrijfskleding is het belangrijk dat het logo, de slogan of afbeelding er professioneel uitziet. Daarom wordt er vaak gekozen voor borduurtechniek om bedrijfskleding te laten bedrukken. Borduren is mogelijk in vrijwel alle kleuren. Daarnaast kunt u per product tot wel 15 kleuren gebruiken. Bevat uw logo veel details? Of wilt u iets laten borduren waar veel verschillende kleuren voor nodig zijn? Kies dan voor borduring. In tegenstelling tot flex- of flock drukken levert het gebruik van meerdere kleuren in een logo of afbeelding nauwelijks extra kosten op.
        </p>
      </div>
      <img
        src={borduurImg}
        alt="Borduren op textiel"
        loading="lazy"
        width={800}
        height={600}
        className="w-full h-auto rounded-2xl"
      />
    </section>

    <section className="mb-12">
      <h2 className="text-2xl font-bold mb-4 text-[#0a2933]">Wat is borduring?</h2>
      <p className="text-muted-foreground mb-4">
        Bij onze drukkerij laat u eenvoudig allerlei soorten textiel snel, eenvoudig en betaalbaar voorzien van een borduurpatroon. Wanneer u kiest voor borduring, worden alle producten bij ons geborduurd, we besteden niets uit. We beschikken over computergestuurde machines en maken gebruik van een zeskoppige borduurmachine. Onze ervaren medewerkers zorgen dat uw product niet alleen professioneel en duurzaam, maar ook mooi geborduurd wordt.
      </p>
      <p className="text-muted-foreground">
        We maken uitsluitend gebruik van kwalitatief hoogwaardig materiaal. Bovendien wordt uw borduring aangebracht met de beste kwaliteit garen. Voor de afwerking maken we gebruik van een goede backing, waarmee we voorkomen dat het te borduren logo of afbeelding na een aantal wasbeurten gaat rafelen. De borduring zal voor lange tijd stevig blijven zitten.
      </p>
    </section>

    <section className="mb-12">
      <h2 className="text-2xl font-bold mb-4 text-[#0a2933]">Wat kost een borduring?</h2>
      <p className="text-muted-foreground">
        Een van de vele voordelen van borduren bij Magic Print is dat we de borduurkaart zelf kunnen maken waardoor wij deze voordelig kunnen aanbieden. Een borduurkaart is een soort sjabloon wat de borduurmachine kan lezen. De borduurkaart bevat dus uw logo, tekst of afbeelding die u wilt laten borduren. Bij veel borduurbedrijven in en rondom Den Haag betaalt u voor een borduurkaart al snel zo'n €50,- euro, maar niet bij Magic Print — <strong>bij ons is de borduurkaart altijd gratis!</strong>
      </p>
    </section>

    <section className="mb-12">
      <h2 className="text-2xl font-bold mb-4 text-[#0a2933]">De voordelen van borduren</h2>
      <ul className="space-y-3">
        {[
          "Vervaardigd in eigen huis door een zeskoppige borduurmachine",
          "Uw eigen logo professioneel laten borduren op meerdere textielsoorten",
          "Tot wel 15 kleuren per product, zonder hoge meerkosten",
          "Borduren is mogelijk in vrijwel alle kleuren",
          "In combinatie met onze producten een perfect en kwalitatief eindresultaat",
        ].map((v) => (
          <li key={v} className="flex items-start gap-2 text-muted-foreground">
            <Check className="w-4 h-4 text-primary mt-0.5 shrink-0" />
            {v}
          </li>
        ))}
      </ul>
    </section>

    <section className="mb-12">
      <h2 className="text-2xl font-bold mb-4 text-[#0a2933]">Fiscaal voordeel</h2>
      <p className="text-muted-foreground">
        Wist u dat het aanschaffen van bedrijfskleding{" "}
        <a href="https://www.belastingdienst.nl/wps/wcm/connect/nl/werk-en-inkomen/content/aftrek-zakelijke-kosten" target="_blank" rel="noopener noreferrer" className="text-primary underline">fiscaal aftrekbaar</a>{" "}
        is? De belastingdienst stelt dat, als er minimaal 70cm² van de kleding is geborduurd met bedrijfsnaam en/of logo, de kosten ten laste kunnen komen van uw bedrijf. Een oppervlakte van 70cm² komt in de praktijk meestal overeen met twee logo's. Bijvoorbeeld een borst- en een ruglogo.
      </p>
    </section>
  </PageLayout>
);

export default Borduren;
